import React from 'react';
import { Container, Button } from 'react-bootstrap';

export default function StepFinalMenorEdad({ reset }) {
  return (
    <Container className="form-container text-center">
      <h2 className="form-title">Fuera de rango de edad</h2>
      <p>
        Actualmente las becas que ofrece la Fundación 3F están destinadas exclusivamente a personas de entre 18 y 29 años.
      </p>
      <p>
        Te sugerimos dirigirte al liceo público más cercano para averiguar las opciones disponibles que mejor se adapten a ti.
      </p>
      <Button variant="secondary" onClick={reset} className="mt-3">
        Reiniciar formulario
      </Button>
    </Container>
  );
}